/**
 * Dev-only console helpers (the unhandled-error warning, the hot-reload registry notice, the SSR
 * no-op warning). Every call is gated on the literal `process.env.NODE_ENV !==
 * "production"` so the dev branch is statically removable in a production build:
 *
 * - ESM/CJS ship the literal untransformed — the consumer's bundler substitutes the token at their
 *   build time (the React convention) and their production minifier drops the dead branch.
 * - The UMD bundle bakes `"production"` via `@rollup/plugin-replace` (see `rollup.config.mjs`); a
 *   bare `process.env` reference would otherwise throw in a script-tag environment.
 *
 * Do NOT replace this with a `typeof process` guard — bundlers replace only the `process.env.NODE_ENV`
 * token, leaving a `typeof` check intact and silently killing dev-mode behavior.
 *
 * This module holds the first (and only) `process.env` reference in `payments/src`.
 *
 * @internal
 */

/** True in development builds (any `NODE_ENV` other than `"production"`). @internal */
export const isDevBuild = (): boolean => process.env.NODE_ENV !== "production";

/** `console.warn` in development builds only; a no-op in production. @internal */
export const devWarn = (...args: unknown[]): void => {
    if (process.env.NODE_ENV !== "production") {
        console.warn(...args);
    }
};

/** `console.error` in development builds only; a no-op in production. @internal */
export const devError = (...args: unknown[]): void => {
    if (process.env.NODE_ENV !== "production") {
        console.error(...args);
    }
};

/** `console.info` in development builds only; a no-op in production. @internal */
export const devInfo = (...args: unknown[]): void => {
    if (process.env.NODE_ENV !== "production") {
        console.info(...args);
    }
};
